// Humm widget
jQuery(document).ready(function(){
    jQuery("body").on("bpfs-theme-built",function(){
        // Boost 2.0
        if(jQuery('.boost-pfs-filter-products > div').length > 0 && jQuery('.product-thumbnail__humm-price').length > 0){
            jQuery('.boost-pfs-filter-products > div').each(function(index){
                jQuery(this).children().find('.product-thumbnail__humm-price').empty().attr('id', 'collwgt'+index);
                let hummprice = jQuery(this).children().find('.money:first').clone();
                hummprice.find('span.money').empty();
                hummprice = hummprice.text().replace(/[^\d.-]/g, '');
                let humm_script = document.createElement('script');
                humm_script.src = "https://d3v2ir16k1una.cloudfront.net/content/scripts/flexifi-widget.js?id=0011n000022om66AAA&productPrice="+hummprice+"&used_in=list";
                humm_script.async = true;
                document.getElementById('collwgt'+index).appendChild(humm_script);
            })
        }
        // Boost Turbo
        if(jQuery('.boost-sd__product-item').length > 0 && jQuery('.product-thumbnail__humm-price').length > 0){
            jQuery('.boost-sd__product-item').each(function(index){
                jQuery(this).find('.product-thumbnail__humm-price').empty().attr('id', 'collwgt'+index);
                let hummprice = jQuery(this).find('.span_money.money').first().text().replace(/[^\d.-]/g, '');
                if(!hummprice) return;
                let humm_script = document.createElement('script');
                humm_script.src = "https://d3v2ir16k1una.cloudfront.net/content/scripts/flexifi-widget.js?id=0011n000022om66AAA&productPrice="+hummprice+"&used_in=list";
                humm_script.async = true;
                document.getElementById('collwgt'+index).appendChild(humm_script);
            })
        }
    });
});
